import todosTypes from "./todos.types";
export default {
  fetchTodoLoading: state =>
    state.type === todosTypes.FETCH_TODOS_REQUEST,
  fetchTodoSuccess: state =>
    state.type === todosTypes.FETCH_TODOS_SUCCESS,
  fetchTodoFailed: state =>
    state.type === todosTypes.FETCH_TODOS_FAILED,

  addTodoLoading: state =>
    state.type === todosTypes.ADD_TODOS_REQUEST,
  addTodoSuccess: state =>
    state.type === todosTypes.ADD_TODOS_SUCCESS,
  addTodoFailed: state =>
    state.type === todosTypes.ADD_TODOS_FAILED,

  updateTodoLoading: state =>
    state.type === todosTypes.UPDATE_TODOS_REQUEST,
  updateTodoSuccess: state =>
    state.type === todosTypes.UPDATE_TODOS_SUCCESS,
  updateTodoFailed: state =>
    state.type === todosTypes.UPDATE_TODOS_FAILED,

  deleteTodoLoading: state =>
    state.type === todosTypes.DELETE_TODOS_REQUEST,
  deleteTodoSuccess: state =>
    state.type === todosTypes.DELETE_TODOS_SUCCESS,
  deleteTodoFailed: state =>
    state.type === todosTypes.DELETE_TODOS_FAILED,
};
